export const messages = {
  en: {
    feeConfigDetail: {
      feeItemInfo: 'Fee Item Information',
      feeType: 'Fee Type',
      feeItem: 'Fee Item',
      feeFlag: 'Fee Flag',
      paymentCycle: 'Payment Cycle',
      billType: 'Reminder Type',
      startTime: 'Start Time',
      endTime: 'End Time',
      deductFrom: 'Account Deduction',
      payOnline: 'Mobile Payment',
      scale: 'Rounding Method',
      rounding: 'Rounding',
      upRound: 'Up Round',
      downRound: 'Down Round',
      decimalPlace: 'Decimal Places',
      computingFormula: 'Calculation Formula',
      squarePrice: 'Unit Price',
      additionalAmount: 'Additional Fee',
      modifyRecord: 'Modification Record',
      createObject: 'Created Objects',
      discount: 'Discount',
      paymentType: 'Payment Type',
      validity: 'Validity Period',
      action: 'Action',
      operator: 'Operator',
      operateTime: 'Operate Time',
      add: 'Add',
      delete: 'Delete',
      modifyNew: 'Modify (New)',
      modifyOld: 'Modify (Old)',
      feeId: 'Fee ID',
      objectType: 'Object Type',
      objectName: 'Object Name',
      ownerName: 'Owner Name',
      phone: 'Phone',
      createTime: 'Create Time',
      selectFeeObject: 'Select Fee Object',
      house: 'House',
      car: 'Car',
      contract: 'Contract',
      discountName: 'Discount Name',
      rule: 'Rule',
      discountType: 'Discount Type',
      breach: 'Breach',
      payStartTime: 'Payment Start Time',
      payEndTime: 'Payment End Time',
      discountEndTime: 'Discount End Time',
      prePayment: 'Prepayment',
      postPayment: 'Postpayment',
      confirmDelete: 'Confirm Delete',
      confirmDeleteDiscount: 'Are you sure to delete this discount?',
      deleteSuccess: 'Delete successfully',
      deleteFailed: 'Delete failed',
      tip1: 'Payment start and end time: Constraints on payment time, i.e. the time when the cashier operates',
      tip2: 'Discount end time: Indicates the maximum payment time',
      tip3: 'If the current year fee cannot enjoy the discount, select the "No Arrears" rule in discount settings with arrears duration 0',
      tip4: 'Then all arrears fees will not enjoy the discount, and the current year fee belongs to arrears so it does not enjoy the discount'
    },
  },
  zh: {
    feeConfigDetail: {
      feeItemInfo: '费用项信息',
      feeType: '费用类型',
      feeItem: '费用项',
      feeFlag: '费用标识',
      paymentCycle: '缴费周期',
      billType: '催缴类型',
      startTime: '开始时间',
      endTime: '结束时间',
      deductFrom: '账户抵扣',
      payOnline: '手机缴费',
      scale: '进位方式',
      rounding: '四舍五入',
      upRound: '向上进位',
      downRound: '向下进位',
      decimalPlace: '保留小数',
      computingFormula: '计算公式',
      squarePrice: '计费单价',
      additionalAmount: '附加费',
      modifyRecord: '修改记录',
      createObject: '创建对象',
      discount: '优惠折扣',
      paymentType: '付费类型',
      validity: '有效期',
      action: '动作',
      operator: '操作人',
      operateTime: '操作时间',
      add: '添加',
      delete: '删除',
      modifyNew: '修改(新)',
      modifyOld: '修改(旧)',
      feeId: '费用编号',
      objectType: '对象类型',
      objectName: '对象名称',
      ownerName: '业主名称',
      phone: '手机号',
      createTime: '创建时间',
      selectFeeObject: '请选择费用对象',
      house: '房屋',
      car: '车辆',
      contract: '合同',
      discountName: '折扣名称',
      rule: '规则',
      discountType: '折扣类型',
      breach: '违约',
      payStartTime: '缴费起始时间',
      payEndTime: '缴费结束时间',
      discountEndTime: '折扣终止时间',
      prePayment: '预付费',
      postPayment: '后付费',
      confirmDelete: '确认删除',
      confirmDeleteDiscount: '确定要删除此折扣吗？',
      deleteSuccess: '删除成功',
      deleteFailed: '删除失败',
      tip1: '缴费起始时间和缴费结束时间：这个约束缴费的时间，也就是前台收银员操作缴费的时间',
      tip2: '折扣终止时间：这个表示最大缴费到什么时候',
      tip3: '如果本年度费用不能享受优惠 那么在折扣设置中规则选择打折无欠费规则，并且欠费时长为0',
tip4: '这样所有欠费的费用则不享受优惠，本年度的费用属于欠费所以不享受优惠'
    },
  },
  'zh-TW': {
    feeConfigDetail: {
      feeItemInfo: '費用項信息',
      feeType: '費用類型',
      feeItem: '費用項',
      feeFlag: '費用標識',
      paymentCycle: '繳費週期',
      billType: '催繳類型',
      startTime: '開始時間',
      endTime: '結束時間',
      deductFrom: '帳戶抵扣',
      payOnline: '手機繳費',
      scale: '進位方式',
      rounding: '四捨五入',
      upRound: '向上進位',
      downRound: '向下進位',
      decimalPlace: '保留小數',
      computingFormula: '計算公式',
      squarePrice: '計費單價',
      additionalAmount: '附加費',
      modifyRecord: '修改記錄',
      createObject: '創建對象',
      discount: '優惠折扣',
      paymentType: '付費類型',
      validity: '有效期',
      action: '動作',
      operator: '操作人',
      operateTime: '操作時間',
      add: '添加',
      delete: '刪除',
      modifyNew: '修改(新)',
      modifyOld: '修改(舊)',
      feeId: '費用編號',
      objectType: '對象類型',
      objectName: '對象名稱',
      ownerName: '業主名稱',
      phone: '手機號',
      createTime: '創建時間',
      selectFeeObject: '請選擇費用對象',
      house: '房屋',
      car: '車輛',
      contract: '合同',
      discountName: '折扣名稱',
      rule: '規則',
      discountType: '折扣類型',
      breach: '違約',
      payStartTime: '繳費起始時間',
      payEndTime: '繳費結束時間',
      discountEndTime: '折扣終止時間',
      prePayment: '預付費',
      postPayment: '後付費',
      confirmDelete: '確認刪除',
      confirmDeleteDiscount: '確定要刪除此折扣嗎？',
      deleteSuccess: '刪除成功',
      deleteFailed: '刪除失敗',
      tip1: '繳費起始時間和繳費結束時間：這個約束繳費的時間，也就是前台收銀員操作繳費的時間',
      tip2: '折扣終止時間：這個表示最大繳費到什麼時候',
      tip3: '如果本年度費用不能享受優惠 那麼在折扣設置中規則選擇打折無欠費規則，並且欠費時長為0',
      tip4: '這樣所有欠費的費用則不享受優惠，本年度的費用屬於欠費所以不享受優惠'
    },
  }
}